<template>
	<div class='Detail'>
		<div class="content_box" v-if="page_data">
			<div class="title">{{page_data.name}}</div>
			<div class="author">来源: {{page_data.author}}</div>
			<div class="source">发布时间: {{page_data.release_time, 'Y年M月D日 h:m:s'| formatDates}}</div>
			<div class="content" v-html="page_data.text_content"></div>

			<div class="proofread" v-if="page_data.plan">策划: {{page_data.plan}}</div>
			<div class="plan" v-if="page_data.edit">编辑: {{page_data.edit}}</div>
			<div class="edit" v-if="page_data.proofread">审校: {{page_data.proofread}}</div>
		</div>
	</div>
</template>
<script>
import ShareServiceDetail from "@/service/ShareServiceDetail.js";
import { formatDates } from "@/assets/js/date.js";

export default {
	name: 'Detail',
	components: {

	},
	data() {
		return {
			page_data: null
		};
	},
	/* 时间过滤 */
	filters: {
		formatDates,
	},
	async mounted() {
		const page_data = await new ShareServiceDetail().detailData(this.$route.query.id)
		this.page_data = page_data
	},
	methods: {

	},
}
</script>
<style lang='stylus' scoped>
.Detail
	width: 100%
	min-height: 100vh
	background-image: url('../../../assets/images/shares/template_red/detail_bg.png')
	background-size: 100%
	background-color: #30558A
	padding-bottom: 0.8rem

	.content_box
		width calc(100% - 1.34rem)
		margin auto
		padding-top: 1.07rem

		.title
			font-size: 0.43rem;
			font-family: Microsoft YaHei;
			font-weight: bold;
			line-height: 0.64rem;
			color: #FFFFFF;

		.author,.source
			font-size: 0.32rem;
			font-family: Microsoft YaHei;
			font-weight: 400;
			line-height: 0.64rem;
			color: #939393;

		.author
			margin-top: 0.8rem

		.content
			font-size: 0.37rem;
			font-family: Microsoft YaHei;
			font-weight: 400;
			line-height: 0.64rem;
			color: #FFFFFF !important
			margin-top: 0.8rem
			text-align: justify

			>>> img
				width 100%
				height auto !important

			>>> section
				font-size: 0.37rem;
				font-family: Microsoft YaHei;
				font-weight: 400;
				line-height: 0.64rem;
				color: #FFFFFF;
				text-align: justify

		.proofread,.plan,.edit
			font-size: 0.32rem;
			font-family: Microsoft YaHei;
			font-weight: 400;
			line-height: 0.64rem;
			color: #939393;

		.proofread
			margin-top: 0.5rem
			padding-top: 0.43rem
			border-top: 1px solid #707070


@media (min-width: 750px)
	body
		width 750px
		margin auto
		overflow hidden
</style>
